import { render, staticRenderFns } from "./CheckoutCartWarning.vue?vue&type=template&id=482dcca8&"
import script from "./CheckoutCartWarning.ts?vue&type=script&lang=ts&"
export * from "./CheckoutCartWarning.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports